import QuotationTopBarV3 from "./QuotationTopBarV3";

export default QuotationTopBarV3;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/index.js